import api from "@/services/api";

export default {
  getCourses() {
    return api.get("/api/courses");
  },
  getCourseById(id) {
    return api.get(`/api/courses/${id}`);
  },
  createCourse(courseData) {
    return api.post("/courses", courseData);
  },
  updateCourse(id, courseData) {
    return api.put(`/courses/${id}`, courseData);
  },
  deleteCourse(id) {
    return api.delete(`/api/courses/${id}`);
  },
};
